import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';

import { FormFocusableService } from '@ts/shared/form/focus/util-core';

import { IonFormFieldFocusableWrapperAbstractUiComponent } from '../ion-form-field-focusable-wrapper-abstract-ui/ion-form-field-focusable-wrapper-abstract-ui.component';

@Component({
  selector: 'ts-ion-form-field-wrapper-ui',
  templateUrl: './ion-form-field-wrapper-ui.component.html',
  styleUrls: ['./ion-form-field-wrapper-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IonFormFieldWrapperUiComponent extends IonFormFieldFocusableWrapperAbstractUiComponent {
  protected formFocusableService = inject(FormFocusableService);

  @ViewChild('scrollHereOnFocus') scrollHereOnFocus!: ElementRef;
}
